export const getPositionExcludingExisting = ({
    existingPositions,
    initialPosition
}) => {
    let lastPosition = initialPosition;

    const getPosition = (index) => {
        const position = index + lastPosition;
        if (existingPositions.includes(position)) {
            lastPosition += 1;

            return getPosition(index);
        }

        return position;
    };

    return getPosition;
};
